<template>
  <form class="enhancements-treat form">
    <div v-if="!haveIcon" class="enhancements-image">
      <picture class="image-wrapper"
               v-lazyload="{
              src: enhancement.icon,
              set: [
                { width: '480', height: '240', breakpoint: 'xs' },
                { width: '800', height: '360', breakpoint: 'md' }
              ],
              fit: 'crop',
              align: 'center'
            }"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          v-bind:alt="enhancement.name"
        />
      </picture>
    </div>
    <div class="enhancements-content-header">{{ enhancement.name }}</div>
    <div class="enhancements-content-description">{{ enhancement.description }}</div>
    <div class="flex-grid-2-col gutter-sm">
      <div class="input dropdown">
        <select
          v-model="occasion"
          name="occasion"
          :placeholder="occasionLabel"
          id="select-occasion"
          aria-required="true"
          :class="[{ 'filled': occasion }]"
        >
          <option
            v-for="option in occasionOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
        <label
          class="floating"
          for="select-occasion"
        >
          {{ occasionLabel }}*
        </label>
      </div>
    </div>
    <div id="celebratory-treat-group" class="enhancements-content-subheader">{{ tc('enhancements.celebratoryTreatDateGroupTitle') }}</div>
    <selectable-group
      v-model="date"
      label-id="celebratory-treat-group"
      :options="dateOptions"
    />

    <div class="flex-grid-2-col">
      <div class="input dropdown">
        <select
          v-model="time"
          name="occasion"
          id="select-date"
          aria-required="true"
          :class="[{ 'filled': time }]"
        >
          <option
            v-for="option in timeOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
        <label
          class="floating req"
          for="select-date"
        >
          {{tc('formFields.time')}}
        </label>
      </div>
    </div>
    <div class="flex-grid-1-col">
      <div class="input">
          <textarea
            v-model="comment"
            name="comment"
            rows="10"
            :class="[{ 'have-value': !!comment }]"
            id="celebratory-treat-comment"></textarea>
        <label
          class="floating"
          for="celebratory-treat-comment"
        >
          {{ commentLabel }}
        </label>
      </div>
    </div>
  </form>
</template>

<script>
  import { getDate } from '@utils/date-helpers'
  import { capitalize } from '@utils/string-helpers'
  import SelectableGroup from '@components/01.base/01.forms/selectable-group/selectable-group.vue'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'celebratory-treat',
    components: { SelectableGroup },
    props: {
      enhancement: {
        type: Object,
        required: true
      },
      data: {
        type: Object
      }
    },
    data: () => ({
      occasionLabel: 'Select an occasion',
      occasion: null,
      dateLabel: 'Select date',
      date: null,
      timeOptionsLabel: 'Time options',
      time: null,
      commentLabel: 'Comment',
      comment: ''
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', [
        'selectedHotel',
        'getRangeInDays'
      ]),
      ...mapState('booking', ['query']),
      haveIcon() {
        return !!this.enhancement.icon.split('is/content')[1]
      },
      isValid() {
        return !!this.occasion && !!this.date && !!this.time
      },
      occasionOptions() {
        return this.enhancement.occasions ?? []
      },
      timeOptions() {
        return this.enhancement.times ?? []
      },
      dateOptionFormat() {
        return 'dddd[,] MMM[.] D'
      },
      dateOptions() {
        return Array.from({ length: this.getRangeInDays + 1 }, (v, i) => `${this.getDayType(i)} • ${this.getDay(i)}`)
      }
    },
    watch: {
      isValid(val) {
        this.$emit('is-valid', val)
      }
    },
    mounted() {
      if (this.data && typeof this.data === 'object') {
        this.occasion = this.data.occasion
        this.date = this.data.date
        this.time = this.data.time
        this.comment = this.data.comment
      }
    },
    methods: {
      getDay(day) {
        return getDate(this.query.stayDateStart)
          .add(day, 'days')
          .format(this.dateOptionFormat)
      },
      getDayType(i) {
        if (i === 0) {
          return this.tc('booking.checkIn')
        } else if (i === this.getRangeInDays) {
          return this.tc('booking.checkOut')
        } else {
          return `${capitalize(this.tc('noums.daySingular'))} ${i + 1}`
        }
      }
    }
  }
</script>
